import React, { forwardRef } from "react";
import { useDispatch } from "react-redux";
import { CustomButton, CustomIconButton, icon, IconComponent } from "../../../../../../common/components";
import styles from "./HelperBox.module.css";
import { setBulkVersioningInProgress } from "../../../../slice/document-center-slice";
import { translate } from "../../../../../../common/providers";

const HelperBox = forwardRef(({ className = "", hasOpenCandidatesDialog = false, onClose, title, subTitle }, ref) => {
	const dispatch = useDispatch();
	const handleInitBulkVersioning = () => {
		dispatch(setBulkVersioningInProgress(true));
	};
	return (
		<div ref={ref} className={`${styles.container} ${className}`}>
			<div className={styles.infoContainer}>
				<IconComponent color="var(--blue-500)" icon={icon.faInfoCircle} size="md" />
				<div className={styles.textContainer}>
					<div className={styles.title}>{title}</div>
					<div>{subTitle}</div>
				</div>
			</div>
			{hasOpenCandidatesDialog ? (
				<div className={styles.actionButtonContainer}>
					<CustomButton
						className={styles.actionButton}
						variant="contained"
						onClick={handleInitBulkVersioning}
					>
						{translate("document-center.table.bulk-versioning-dialog.title")}
					</CustomButton>
				</div>
			) : (
				<div>
					<CustomIconButton icon={icon.faTimes} size="xs" onClick={onClose} />
				</div>
			)}
		</div>
	);
});

export default HelperBox;
